'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializePubSub = undefined;

var _reduxActions = require('redux-actions');

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _makeRequestActionTypes = require('conversations-internal-clients/action-creators/operators/makeRequestActionTypes');

var _AblyRealtime = require('conversations-internal-pub-sub/ably/builders/AblyRealtime');

var _ConversationsPubSub = require('conversations-internal-pub-sub/conversations-pub-sub/client/ConversationsPubSub');

var _statusComparators = require('conversations-internal-schema/async-data/operators/statusComparators');

var _getToken = require('../clients/getToken');

var _networkOnline = require('../../actions/PubSubStatusActions/networkOnline');

var _networkOffline = require('../../actions/PubSubStatusActions/networkOffline');

var _asyncActionTypes = require('../constants/asyncActionTypes');

var _getSessionId = require('../../selectors/widgetDataSelectors/getSessionId');

var _getAsyncPubSubClient = require('../selectors/getAsyncPubSubClient');

var _subscribeToThreadChannels = require('../../actions/ConversationsActions/subscribeToThreadChannels');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pubSubActions = (0, _makeRequestActionTypes.makeRequestActionTypes)(_asyncActionTypes.INITIALIZE_PUBSUB);

var initializePubSubStarted = (0, _reduxActions.createAction)(pubSubActions.STARTED);
var initializePubSubSucceeded = (0, _reduxActions.createAction)(pubSubActions.SUCCEEDED);
var initializePubSubFailed = (0, _reduxActions.createAction)(pubSubActions.FAILED);

var initializePubSub = exports.initializePubSub = function initializePubSub() {
  return function (dispatch, getState) {
    var asyncPubSubClient = (0, _getAsyncPubSubClient.getAsyncPubSubClient)(getState());
    if ((0, _statusComparators.isStarted)(asyncPubSubClient) || (0, _statusComparators.isSucceeded)(asyncPubSubClient)) {
      return _q2.default.Promise.resolve();
    }

    var clientOptions = {
      authCallback: function authCallback(tokenParams, callback) {
        var sessionId = (0, _getSessionId.getSessionId)(getState());

        (0, _getToken.getToken)({ sessionId: sessionId }).then(function (tokenRequest) {
          return callback(null, tokenRequest);
        }, function (error) {
          return callback(error);
        });
      }
    };

    var lifecycleHooks = {
      onConnect: function onConnect() {
        dispatch((0, _networkOnline.networkOnline)());
        dispatch(initializePubSubSucceeded({ client: client })); // eslint-disable-line
        dispatch((0, _subscribeToThreadChannels.subscribeToThreadChannels)());
      },
      onDisconnect: function onDisconnect() {
        dispatch((0, _networkOffline.networkOffline)());
      },
      onFailure: function onFailure() {
        dispatch((0, _networkOffline.networkOffline)());
      },
      onReconnect: function onReconnect() {
        dispatch((0, _networkOnline.networkOnline)());
        dispatch(initializePubSubSucceeded({ client: client })); // eslint-disable-line
        dispatch((0, _subscribeToThreadChannels.subscribeToThreadChannels)());
      }
    };

    var vendor = (0, _AblyRealtime.AblyRealtime)(clientOptions, lifecycleHooks);
    var client = new _ConversationsPubSub.ConversationsPubSub(vendor);

    dispatch(initializePubSubStarted());
    var promise = client.connect();
    promise.catch(function (error) {
      return dispatch(initializePubSubFailed(error));
    }).done();
    return promise;
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/pubsub/actions/initializePubSub.js
// module id = 222
// module chunks = 2 3